import React from 'react';

/**
 * Şifre hata mesajı gösterimi için reusable component
 * Kırmızı, küçük font ile hata mesajlarını gösterir
 * 
 * Kullanım:
 * <PasswordError error={passwordError} />
 */
const PasswordError = ({ error }) => {
  if (!error) return null;

  return (
    <p className="text-xs text-red-600 mt-1">
      {error}
    </p>
  );
};

export default PasswordError;
